export default "__VITE_ASSET__CkldZOsH__"